export interface ParsedTable {
  header: Array<string>;
  rows: Array<Array<string>>;
}

/** table_content is server-generated HTML from our own pipeline (page_generator/table
 * extraction), not user input. Parsing it into cells lets callers render through real Table
 * components instead of a raw dangerouslySetInnerHTML blob. */
export function parseTableContent(html: string): ParsedTable | null {
  const table = new DOMParser().parseFromString(html, 'text/html').querySelector('table');
  const rowEls = table ? Array.from(table.querySelectorAll('tr')) : [];
  if (rowEls.length === 0) {return null;}

  const isHeaderRow = (row: Element) =>
    row.children.length > 0 && Array.from(row.children).every((cell) => cell.tagName === 'TH');

  const [firstRow] = rowEls;
  const header =
    firstRow && isHeaderRow(firstRow)
      ? Array.from(firstRow.children).map((cell) => cell.innerHTML)
      : [];
  const bodyRowEls = header.length > 0 ? rowEls.slice(1) : rowEls;
  const rows = bodyRowEls.map((row) => Array.from(row.children).map((cell) => cell.innerHTML));

  return { header, rows };
}
